export default __webpack_public_path__ + "static/media/wishlist.cd699b62.svg";